define('OutSystems/ReactView/ScreenLoader',["require", "exports", "tslib", "OutSystems/ClientRuntime/EventDispatcher", "OutSystems/ClientRuntime/Navigation", "OutSystems/ClientRuntime/RequireManager", "OutSystems/ClientRuntime/ScreenStateCache", "./BaseView", "./CheckPermissionsNavigationCallbacks", "./ControllerInitializationNavigationCallbacks", "./findRouteMatch", "./RouteComponents"], function (require, exports, tslib_1, EventDispatcher_1, Navigation, RequireManager, ScreenStateCache_1, BaseView_1, CheckPermissionsNavigationCallbacks_1, ControllerInitializationNavigationCallbacks_1, findRouteMatch_1, RouteComponents_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ScreenLoader = (function () {
        function ScreenLoader(runtime, routes, splashRoute) {
            this.runtime = runtime;
            this.routes = routes;
            this.splashRoute = splashRoute;
            this.isFirstNavigation = true;
            this.loadedComponents = [];
        }
        ScreenLoader.prototype.getLoadedComponent = function (key) {
            for (var i = this.loadedComponents.length - 1; i >= 0; i--) {
                if (this.loadedComponents[i] && this.loadedComponents[i].key === key) {
                    return this.loadedComponents[i].component;
                }
            }
            return null;
        };
        ScreenLoader.prototype.freeLoadedComponent = function (key) {
            for (var i = this.loadedComponents.length - 1; i >= 0; i--) {
                if (this.loadedComponents[i] && this.loadedComponents[i].key === key) {
                    this.loadedComponents = this.loadedComponents.slice(i + 1, this.loadedComponents.length);
                }
            }
        };
        ScreenLoader.prototype.load = function (location, action, history) {
            var _this = this;
            var routeMatch = findRouteMatch_1.default(this.runtime.shouldRenderSplashScreen() ? [this.splashRoute] : this.routes, location);
            if (!routeMatch) {
                return null;
            }
            var routeInfo = routeMatch.routeInfo, matchedParams = routeMatch.matchedParams;
            var component = routeInfo.component, lazyComponentInfo = routeInfo.lazyComponentInfo;
            if (component) {
                return Promise.resolve(component);
            }
            var loadedComponent = { key: location.key, component: null };
            this.loadedComponents.push(loadedComponent);
            return new Promise(function (resolve, reject) {
                RequireManager.loadModule([lazyComponentInfo.viewModuleName]);
                RequireManager.loadModule([
                    lazyComponentInfo.modelModuleName,
                    lazyComponentInfo.controllerModuleName,
                    lazyComponentInfo.webFlowControllerModuleName,
                ], function (modelFactory, controllerFactory, flowControllerModule) {
                    var checkPermissionsNavigationCallbacks = new CheckPermissionsNavigationCallbacks_1.default(history, _this.runtime, function () { return _this.isFirstNavigation; });
                    var controllerInitializationNavigationCallbacks = new ControllerInitializationNavigationCallbacks_1.default(history, _this.runtime);
                    var screenStateCache = null;
                    var viewWasRestoredFromCache = false;
                    var isNavigatingFromHistory = !_this.isFirstNavigation && Navigation.locationReachedFromHistory(tslib_1.__assign(tslib_1.__assign({}, location), { action: action }));
                    if (isNavigatingFromHistory) {
                        screenStateCache = ScreenStateCache_1.ScreenStateCache.loadScreenCache(location.key);
                        if (screenStateCache) {
                            var screenCachedModel_1 = screenStateCache.components[BaseView_1.SCREEN_UUID].state;
                            if (screenCachedModel_1) {
                                var originalModelFactory_1 = modelFactory;
                                var cachedModelFactory = {
                                    create: function (context) {
                                        var model = originalModelFactory_1.create(context);
                                        model.fromImmutableData(screenCachedModel_1);
                                        return model;
                                    },
                                };
                                modelFactory = cachedModelFactory;
                                viewWasRestoredFromCache = true;
                            }
                        }
                    }
                    if (!viewWasRestoredFromCache) {
                        var originalModelFactory_2 = modelFactory;
                        var newModelFactory = {
                            create: function (context) {
                                var model = originalModelFactory_2.create(context);
                                model.setInputs(matchedParams);
                                return model;
                            },
                        };
                        modelFactory = newModelFactory;
                    }
                    controllerFactory
                        .initialize({
                        viewName: routeInfo.screenName,
                        navigatedFromHistory: isNavigatingFromHistory,
                        viewWasRestoredFromCache: viewWasRestoredFromCache,
                    }, modelFactory, flowControllerModule.default, checkPermissionsNavigationCallbacks, controllerInitializationNavigationCallbacks)
                        .then(function (result) {
                        if (!result.permissionsOk) {
                            EventDispatcher_1.EventDispatcher.dispatch({
                                type: EventDispatcher_1.EventType.TransitionEnd,
                                args: EventDispatcher_1.TransitionEndResult.Failure,
                            });
                            reject(new Error("Invalid Permissions"));
                            return;
                        }
                        if (_this.loadedComponents.length === 0 ||
                            _this.loadedComponents[_this.loadedComponents.length - 1] !== loadedComponent) {
                            reject(new Error("No longer on screen"));
                            return;
                        }
                        if (!result.controller || !result.model) {
                            reject(new Error("Error loading screen dependencies"));
                            return;
                        }
                        if (routeInfo.screenName !== result.controller.constructor.activeScreen.viewName) {
                            reject(new Error("Screen is no longer active"));
                            return;
                        }
                        RequireManager.loadModule([lazyComponentInfo.viewModuleName], function (viewComponent) {
                            var viewWrapper = RouteComponents_1.createView(viewComponent, result.controller, result.model, screenStateCache, lazyComponentInfo.shallSaveStateOnLeave);
                            BaseView_1.BaseWebScreen.loadResources(viewComponent).then(function () {
                                _this.isFirstNavigation = false;
                                loadedComponent.component = viewWrapper;
                                resolve(viewWrapper);
                            });
                        });
                    });
                });
            });
        };
        return ScreenLoader;
    }());
    exports.default = ScreenLoader;
});
//# sourceMappingURL=ScreenLoader.js.map;
